var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleModalBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 603,
    viewBox: "0 0 375 603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1075",
    x: 0,
    y: 0,
    width: 375,
    height: 603,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.702
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_1039",
    x: 42.5,
    y: 87.044,
    width: 290.517,
    height: 464.753,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(0.283 -112.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.28, 112.5)",
    filter: "url(#Path_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1075-2",
    "data-name": "Path 1075",
    d: "M25,0H323a7,7,0,0,1,7,7V146.614l-4.322,1.216L330,153.563V316.681s-6.771-3.607-6.771-1.137S330,326.56,330,326.56V533a7,7,0,0,1-7,7H296.225l-6.146-3.072L284.408,540H25a7,7,0,0,1-7-7V291.471l4.087-5.917L18,276.4V62.788l3.922-8.875L18,48.478V7A7,7,0,0,1,25,0Z",
    transform: "translate(13.5 28.5)",
    fill: "#582100"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M25,0H323a7,7,0,0,1,7,7V146.614l-4.322,1.216L330,153.563V316.681s-4.907-2.47-4.907,0S330,326.56,330,326.56V533a7,7,0,0,1-7,7H294.631l-5.252-4.274L285.014,540H25a7,7,0,0,1-7-7V291.471l4.087-5.917L18,276.4V62.788l3.922-8.875L18,48.478V7A7,7,0,0,1,25,0Z",
    transform: "translate(13.217 138)",
    fill: "#925029"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.28, 112.5)",
    filter: "url(#Path_1039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1039-2",
    "data-name": "Path 1039",
    transform: "translate(42.5 87.04)",
    fill: "#fff2b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 284.4999389648438 454.7529296875 L 155.7406768798828 454.7529296875 L 147.3820648193359 446.8029479980469 L 146.169189453125 445.6493530273438 L 145.7282409667969 447.2640380859375 L 143.6829833984375 454.7529296875 L 6.016594886779785 454.7529296875 C 3.250418424606323 454.7529296875 1.000006675720215 452.5012817382812 1.000006675720215 449.7335815429688 L 1.000006675720215 404.5989074707031 L 5.332418441772461 399.7738647460938 L 6.284947872161865 398.7130432128906 L 4.963182926177979 398.1786499023438 L 1.000006675720215 396.5762939453125 L 1.000006675720215 6.019405841827393 C 1.000006675720215 3.251700162887573 3.250418424606323 0.9999942779541016 6.016594886779785 0.9999942779541016 L 284.4999389648438 0.9999942779541016 C 287.26611328125 0.9999942779541016 289.5166015625 3.251700162887573 289.5166015625 6.019405841827393 L 289.5166015625 76.39826202392578 C 289.1339111328125 76.70554351806641 288.5395812988281 77.21607208251953 287.9435424804688 77.85975646972656 C 286.5462951660156 79.36858367919922 285.837890625 80.83393859863281 285.837890625 82.21523284912109 C 285.837890625 83.58876037597656 286.5417175292969 85.07693481445312 287.9299011230469 86.63846588134766 C 288.5343627929688 87.31845092773438 289.1368408203125 87.86062622070312 289.5166015625 88.181396484375 L 289.5166015625 301.4469909667969 L 283.6383056640625 311.4270629882812 L 283.1851196289062 312.1964721679688 L 283.8984680175781 312.7334594726562 L 289.5166015625 316.963134765625 L 289.5166015625 449.7335815429688 C 289.5166015625 452.5012817382812 287.26611328125 454.7529296875 284.4999389648438 454.7529296875 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.0166015625 2 C 3.80181884765625 2 2 3.80303955078125 2 6.01934814453125 L 2 395.9019165039062 L 7.981475830078125 398.3204040527344 L 2 404.9819641113281 L 2 449.7335205078125 C 2 451.9498291015625 3.80181884765625 453.7529296875 6.0166015625 453.7529296875 L 142.9194183349609 453.7529296875 L 145.6455383300781 443.7711181640625 L 156.1402893066406 453.7529296875 L 284.4999389648438 453.7529296875 C 286.7147216796875 453.7529296875 288.5166015625 451.9498291015625 288.5166015625 449.7335205078125 L 288.5166015625 317.4620361328125 L 281.870361328125 312.4582824707031 L 288.5166015625 301.1744384765625 L 288.5166015625 88.6361083984375 C 288.1351318359375 88.29486083984375 287.658203125 87.83798217773438 287.1824645996094 87.30282592773438 C 285.626708984375 85.55276489257812 284.837890625 83.841064453125 284.837890625 82.21524047851562 C 284.837890625 79.45071411132812 287.190673828125 77.05484008789062 288.5166015625 75.9241943359375 L 288.5166015625 6.01934814453125 C 288.5166015625 3.80303955078125 286.7147216796875 2 284.4999389648438 2 L 6.0166015625 2 M 6.0166015625 0 L 284.4999389648438 0 C 287.8228759765625 0 290.5166015625 2.69500732421875 290.5166015625 6.01934814453125 L 290.5166015625 76.89080810546875 C 290.5166015625 76.89080810546875 286.837890625 79.51162719726562 286.837890625 82.21524047851562 C 286.837890625 84.9188232421875 290.5166015625 87.70516967773438 290.5166015625 87.70516967773438 L 290.5166015625 301.7196350097656 L 284.4999389648438 311.9345703125 L 290.5166015625 316.4642944335938 L 290.5166015625 449.7335205078125 C 290.5166015625 453.0579223632812 287.8228759765625 455.7529296875 284.4999389648438 455.7529296875 L 155.341064453125 455.7529296875 L 146.6928863525391 447.5274658203125 L 144.4464721679688 455.7529296875 L 6.0166015625 455.7529296875 C 2.6937255859375 455.7529296875 0 453.0579223632812 0 449.7335205078125 L 0 404.2158203125 L 4.588348388671875 399.1057739257812 L 0 397.2505798339844 L 0 6.01934814453125 C 0 2.69500732421875 2.6937255859375 0 6.0166015625 0 Z",
    stroke: "none",
    fill: "#e6c978"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleModalBody);
export default __webpack_public_path__ + "static/media/title-modal-body.153f4d4c55e3d7d1a895fd926586df04.svg";
export { ForwardRef as ReactComponent };